import { useState } from "react";
import { LockTwoTone, MailTwoTone } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import { Button, CircularProgress, TextField, Box, Typography, Paper, Divider, InputAdornment } from "@mui/material";
import { useFormik } from "formik";
import * as yup from "yup";
import useStorage from "../../hooks/sessionstore";
import httprequest from "../../services/httprequest";

function Loginscreen() {
  let history = useHistory();
  const { setItem } = useStorage();
  const { signIn } = httprequest();
  const [spinner, setSpinner] = useState(false);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: yup.object({
      email: yup.string().email().required("Please enter your valid email"),
      password: yup
        .string()
        .required("Please enter your valid password")
        .min(6),
    }),
    onSubmit: (values) => {
      const reqData = {
        email: values?.email,
        password: values?.password,
      };
      submitSignin(reqData);
    },
  });

  async function submitSignin(reqData) {
    setSpinner(true);
    await signIn(reqData, (res) => {
      if (res.status) {
        setSpinner(false);
        setItem("token", res?.access_token);
        setItem("authUser", res?.data);
        history.push("/certificates");
      }
    });
    setSpinner(false);
  }

  return (
    <Box className="bg-[#ececec] flex justify-center items-center h-screen">
      <Paper
        elevation={6}
        sx={{
          width: 400,
          p: 4,
          borderRadius: 3,
          backgroundColor: "#fff",
        }}
      >
        <Typography variant="h5" align="center" fontWeight={600} gutterBottom>
          Welcome, MediIndia 👋
        </Typography>
        <Typography variant="body2" align="center" color="text.secondary">
          Sign in to continue to MediIndia
        </Typography>

        <form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          <Box mt={3}>
            <TextField
              fullWidth
              label="Email"
              name="email"
              variant="outlined"
              size="medium"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start" sx={{ mr: 1 }}>
                    <MailTwoTone />
                  </InputAdornment>
                ),
              }}
              value={validation.values.email || ""}
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              error={validation.touched.email && Boolean(validation.errors.email)}
              helperText={validation.touched.email && validation.errors.email}
            />
          </Box>

          <Box mt={2}>
            <TextField
              fullWidth
              type="password"
              label="Password"
              name="password"
              variant="outlined"
              size="medium"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start" sx={{ mr: 1 }}>
                    <LockTwoTone />
                  </InputAdornment>
                ),
              }}
              value={validation.values.password || ""}
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              error={validation.touched.password && Boolean(validation.errors.password)}
              helperText={validation.touched.password && validation.errors.password}
            />
          </Box>

          <Box mt={4}>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              size="large"
              sx={{ borderRadius: 2, textTransform: "none", fontWeight: 600 }}
              disabled={spinner}
            >
              {spinner ? <CircularProgress size={24} color="inherit" /> : "Login"}
            </Button>
          </Box>
        </form>

        <Divider sx={{ my: 4 }} />

        <Typography variant="caption" display="block" align="center" color="text.secondary">
          © MediIndia.in - 2025 (09.06.03)
        </Typography>
      </Paper>
    </Box>
  );
}
export default Loginscreen;